import { render, staticRenderFns } from "./Program.vue?vue&type=template&id=7ff039d0&lang=pug&"
import script from "./Program.vue?vue&type=script&lang=js&"
export * from "./Program.vue?vue&type=script&lang=js&"
import style0 from "./Program.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ff039d0')) {
      api.createRecord('7ff039d0', component.options)
    } else {
      api.reload('7ff039d0', component.options)
    }
    module.hot.accept("./Program.vue?vue&type=template&id=7ff039d0&lang=pug&", function () {
      api.rerender('7ff039d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/Program.vue"
export default component.exports